import { useQuery } from '@tanstack/react-query';
import { problemText, useApi, useApiProblem } from '@/shared/api';
import { STRATEGY_LABEL } from '../configuration/ProfileChoiceCards';

/** Strategie einer Entscheidung über die exakte Profilversion (`pricing-strategy-profiles/{id}`). */
export function useHistoryStrategy(versionId: string | null | undefined) {
  const api = useApi();
  const profile = useQuery({
    queryKey: ['pricing-strategy-profile', versionId],
    queryFn: () => api.pricingStrategyProfiles.get(versionId!),
    enabled: Boolean(versionId),
    staleTime: 5 * 60_000,
  });
  const problem = useApiProblem(profile.error ?? null);
  if (!versionId) return 'ohne Strategie';
  if (profile.data) {
    return `${STRATEGY_LABEL[profile.data.strategy] ?? profile.data.strategy} · Version ${profile.data.versionNumber}`;
  }
  if (profile.isError) return problemText(problem, 'nicht ladbar');
  return profile.isPaused ? 'keine Verbindung' : 'wird geladen …';
}
